<!--我的收藏-->
<template>
  <div class="collection-container">
    <div class="collection-content">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="商品" name="first">
          <div class="recommend" v-if="collectionGoods.length>0" :style="'min-height:'+min_height+'px;'">
            <el-row :gutter="16">
              <el-col :span="6" v-for="goods of collectionGoods">
                <div @click="productDetails(goods)">
                  <el-image style="width: 100%; height: 100%;border-radius: 8px;" :src="goods.goodsHomeSearch.image"/>
                  <p class="recommend-title SourceHanSansCN">{{goods.goodsHomeSearch.name}}</p>
                  <div class="preferential-amount" v-if="goods.goodsHomeSearch.preferentialAmount">
                    <div class="preferential">{{goods.goodsHomeSearch.preferentialAmount}}</div>
                  </div>
                  <p class="recommend-price SourceHanSansCN"><span>￥</span>{{parseFloat(goods.goodsHomeSearch.price).toFixed(2)}}</p>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="recommend" v-else :style="'min-height:'+min_height+'px;'">
            <el-empty description="暂无收藏商品"/>
          </div>
          <!-- 分页 -->
          <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage" :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
        </el-tab-pane>
        <el-tab-pane label="资讯" name="second">
          <div :style="'min-height:'+min_height+'px;'" v-if="information.length>0">
            <div class="info-list" v-for="info of information" @click="details(info)">
              <div v-if="info.photo.length<1">
                <p class="span-bold">{{ info.title ? info.title : info.forward }}</p>
                <p>
                  <span v-if="info.is_top==1" class="span-red">置顶</span>
                  <span class="span-default">{{ info.user_name }}</span>
                  <span class="span-default">{{ info.time }}</span>
                </p>
              </div>
              <div v-else-if="info.photo.length<3">
                <el-row>
                  <el-col :span="5">
                    <el-image :src="info.photo[0]" style="height: 110px;width: 100%"></el-image>
                    <i class="iconfont icon-bofang" v-if="info.type==2"></i>
                  </el-col>
                  <el-col :span="19" style="padding-left: 10px;">
                    <p class="p-bold">{{ info.title }}</p>
                    <p>
                      <span v-if="info.is_top==1" class="span-red">置顶</span>
                      <span class="span-default">{{ info.user_name }}</span>
                      <span class="span-default">{{ info.time }}</span>
                    </p>
                  </el-col>
                </el-row>
              </div>
              <div v-else>
                <p class="span-bold">{{ info.title }}</p>
                <el-row>
                  <el-col :span="5" v-for="(photo,index) of info.photo" v-if="index<3" class="imgs">
                    <el-image :src="photo" style="height: 110px;width: 100%"></el-image>
                  </el-col>
                </el-row>
                <p>
                  <span v-if="info.is_top==1" class="span-red">置顶</span>
                  <span class="span-default">{{ info.user_name }}</span>
                  <span class="span-default">{{ info.time }}</span>
                </p>
              </div>
            </div>
          </div>
          <div :style="'min-height:'+min_height+'px;'" v-else>
            <el-empty description="暂无收藏资讯"/>
          </div>
          <!-- 分页 -->
          <page :total="tablePage2.total" class="pagination" @currentPage="currentPage2" :limit="tablePage2.pageSize" style="padding: 0px 25px 15px 10px;"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import page from "@/components/page/pages";
import {serviceCollectionList,collection} from '@/api/interfaceApi'
export default {
  name: "mineCollection",
  components:{page},
  data(){
    return{
      activeName:'first',
      collectionGoods:[],
      information:[],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tablePage2: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      min_height: document.documentElement.clientHeight - 445,
    }
  },
  methods:{
    /*获取收藏商品数据*/
    getServiceCollectionList(){
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      serviceCollectionList({
        userId: cid!=0 && cid!=undefined ? cid : 0,
        pageNum: parseInt(JSON.parse(JSON.stringify(this.tablePage.currentPage)))-1,
        request:'form',
        isHead: true,
        uid: cid!=0 && cid!=undefined ? cid : 0,
      }).then(res=>{
        if (res.code==200){
          if (res.content){
            this.collectionGoods=res.content.goodsCollectionList;
            this.tablePage.total=res.content.totalNum;
          }
        }
      })
    },
    /*获取收藏资讯数据*/
    getCollection(){
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      collection({page: this.tablePage2.currentPage, uid: cid!=0 && cid!=undefined ? cid : 0}).then(res=>{
        if (res.code==200){
          this.information=res.content;
        }
      })
    },
    /*产品详情*/
    productDetails(rows){
      this.$router.push({
        path: '/cloudPlatform/productDetails',
        query: {
          id: rows.id,
          pName: this.pName,
          nextName:'我的收藏'
        },
      })
    },
    /*查看详情*/
    details(row){
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      if (row.type == 2) {
        let routeData = this.$router.resolve({
          name: "videoDetails",
          query:{
            id:row.id,
            type:row.type,
          },
          params:{cid:this.cid},
          path: '/article/videoDetails',
        });
        window.open(routeData.href, '_blank')
      } else {
        if (row.cid == 0) {
          let routeData = this.$router.resolve({
            name: "articleDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/articleDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "dynamic") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "policy") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "notice") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        }
      }
    },
    //切换分页
    currentPage2(page) {
      this.tablePage2.currentPage = page;
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getServiceCollectionList();
    },
    /*切换标签页*/
    handleClick(tab, event) {
      if (tab.name=='first'){
        this.getServiceCollectionList();
      }else{
        this.getCollection();
      }
    }
  },
  mounted() {
    this.getServiceCollectionList();
  }
}
</script>
<style scoped>
.collection-container >>> .collection-content .el-tabs--card>.el-tabs__header {
  border-bottom: none;
}
.collection-container >>> .collection-content .el-tabs--card>.el-tabs__header .el-tabs__item {
  border-bottom: none;
  border-left: none;
}
.collection-container >>> .collection-content .el-tabs__item:hover {
  color: #333333;
}
.collection-container >>> .collection-content .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
  border-radius: 4px 4px 0 0;
  box-sizing: border-box;
}
.collection-container >>> .collection-content .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #FFF;
  background: #FE273B;
  color: #ffffff;
  border-radius: 6px;
}
</style>
<style scoped lang="scss">
.collection-container{
  background: #ffffff;
  padding: 20px;
  .collection-content{
    .recommend{
      .el-col-6 {
        padding-bottom: 20px;
        min-height: 350px;
        .recommend-title{
          margin-block-start: 0;
          margin-block-end: 0;
          font-size: 16px;
          color: #333333;
          padding: 8px 0px;
        }
        .recommend-price{
          font-size: 18px;
          color: #FE273B;
          margin-block-start: 0;
          margin-block-end: 0;
          span{
            font-size: 14px;
            padding-right: 3px;
          }
        }
        .preferential-amount{
          cursor: pointer;
          line-height: 24px;
          text-align: center;
          font-size: 14px;
          color: #FE273B;
          .preferential{
            background: url("~@/assets/img/cloud/coupon.png");
            width: 120px;
            height: 24px;
            background-size: 100% 100%;
          }
        }
      }
    }
    .info-list {
      padding: 15px 0px;
      .span-bold {
        font-size: 20px;
        font-family: 'SourceHanSansCN';
        color: #333;
        margin-block-start: 0em;
        margin-block-end: 0em;
      }
      .p-bold{
        font-size: 18px;
        font-weight: 100;
        font-family: 'SourceHanSansCN';
        color: #333;
        margin-block-start: 0em;
        margin-block-end: 0em;
        min-height: 80px;
      }
      .imgs{
        margin-right: 10px;
        margin-top: 10px;
      }
      p {
        font-size: 16px;
        margin-block-start: 10px;
        margin-block-end: 10px;

        .span-red {
          color: #FE273B;
          font-size: 14px;
          padding-right: 20px;
          font-weight: 100;
          font-family: 'SourceHanSansCN';
        }

        .span-default {
          color: #999999;
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          font-weight: 100;
          padding-right: 20px;
        }
      }
      .icon-bofang{
        font-size: 30px;
        color: white;
        margin-top: 4.5%;
        position: absolute;
        margin-left: -12.2%;
      }
    }
  }
}
</style>